/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Auth_Error_TitleInputs */

const es_login_auth_error_title = /** @type {(inputs: Login_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al iniciar sesión`)
};

const en_login_auth_error_title = /** @type {(inputs: Login_Auth_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in error`)
};

/**
* | output |
* | --- |
* | "Sign-in error" |
*
* @param {Login_Auth_Error_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_auth_error_title = /** @type {((inputs?: Login_Auth_Error_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Auth_Error_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_auth_error_title(inputs)
	return en_login_auth_error_title(inputs)
});
export { login_auth_error_title as "login.auth_error.title" }